
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'b-row',
    setup() {
        return {};
    },
});
